 $(function() {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    let prefix;
    switch (language) {
        case "is-en":
        case "is":
            prefix = "youpret_iceland";
            break;
        case "ee":
        case "ee-en":
        case "ee-ru":
            prefix = "youpret_estonia";
            break;
        default:
            prefix = "youpret";
    }
    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json",
         headers: {
            "X-TimeZoneName": timeZoneName,
            "X-Language": language,
            "X-Prefix": prefix
        },
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: language == "is" 
         ? "/is/takk-fyrir-guide/" 
        : "/is-en/thank-you-guide/"
                        };

    $("#icelandGuideForm").on("submit", function(event) {
        event.preventDefault();
        if ($('#icelandGuideForm')[0].checkValidity() && $('#icelandGuideCheckbox').is(':checked')) {
            $("#icelandGuideSendBtn").prop("disabled", true);
            $("#icelandGuideSendBtn").css("background-color", "#6c757d");
            let email = $("#icelandGuideEmail").val();
            let firstName = $("#icelandGuideFirstName").val();
            let lastName = $("#icelandGuideLastName").val();
            let message = $("#icelandGuideMessage").val();
            let code = "";
            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                additionalInformation: message,
                competitionName: "icelandGuide",
                uri: language == "is" ? "/is/iceland-breakthrough/" : "/is-en/iceland-breakthrough/",
                languageCode: language,
                code: code,
            };


            getRecaptchaToken().then(function(token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function() {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function(err) {
                    console.error(err);
                    $("#icelandGuideSendBtn").prop("disabled", false);
                    $("#icelandGuideSendBtn").css("background-color", "#28a745");
                });
            });
        }
    });

    // Function to toggle button state based on form validity and checkbox
    function toggleSendButtonState() {
        const formValid = $('#icelandGuideForm')[0].checkValidity();
        const checkboxChecked = $('#icelandGuideCheckbox').is(':checked');

        if (formValid && checkboxChecked) {
            // Enable button and change color
            $("#icelandGuideSendBtn").prop("disabled", false);
            $("#icelandGuideSendBtn").css("background-color", "#28a745"); // Change to your desired color (e.g., green)
        } else {
            // Disable button and reset color
            $("#icelandGuideSendBtn").prop("disabled", true);
            $("#icelandGuideSendBtn").css({
                "background-color": "#6c757d", // Change to your disabled color (e.g., grey)
                "border": "none",
                "outline": "none"
            });
        }
    }

    // Trigger the button state change on input and checkbox changes
    $('#icelandGuideForm input, #icelandGuideCheckbox').on('input change', toggleSendButtonState);



    // Initial button state check
    toggleSendButtonState();
});

